import { Befehl } from '../models'
import { findAuftrag, hasFieldContent } from './helpers'
import { hasBefehlGenericEmptyFields } from './generic'
import {
  BefehlAuftrag_1_10Dto,
  Feld_1_11_1Dto,
  Feld_1_11_2Dto,
  Feld_1_12_1Dto,
  Feld_1_12_2Dto,
  Feld_1_13_1Dto,
  Feld_1_13_2Dto
} from '../dtos/befehl-1-dto'

/**
 * Checks if Befehl 1 has empty fields.
 *
 * First checks if ANY field is empty (generic check).
 * Then checks specific business rules:
 * - 1.10: For each existing zeile, requires either km OR (signal + zugmeldestelle)
 * - 1.95: checks freitext field if it exists
 *
 * Aufträge without felder are never considered to have empty fields.
 * Boolean field values are never considered empty fields.
 */
export function hasBefehl1EmptyFields(befehl: Befehl): boolean {
  if (!befehl?.auftraege?.length) return false

  // First check if ANY field is empty using generic check
  if (hasBefehlGenericEmptyFields(befehl)) {
    return true
  }
  if (hasAuftrag1_10emptyFields(befehl)) {
    return true
  }

  // Check 1.95 freitext if exists
  const auftrag195 = findAuftrag(befehl, '1.95')
  if (auftrag195 && !hasFieldContent(auftrag195, '1.96', 'freitext')) {
    return true
  }

  // All checks passed - no empty fields
  return false
}

// Check specific business rules for 1.10
function hasAuftrag1_10emptyFields(befehl: Befehl): boolean {
  const auftrag110 = findAuftrag(befehl, '1.10') as BefehlAuftrag_1_10Dto
  if (auftrag110?.felder && auftrag110.felder.length > 0) {
    // For each existing zeile, check if it has incomplete content

    for (const feld of auftrag110.felder) {
      if (isFieldEmpty(feld, auftrag110)) {
        return true
      }
    }
  } else if (auftrag110) {
    return true // If neither, "km" nor "Signal, Zugmeldestelle" was selected.
  }
  return false
}

function isFieldEmpty(
  feld:
    | Feld_1_11_1Dto
    | Feld_1_11_2Dto
    | Feld_1_12_1Dto
    | Feld_1_12_2Dto
    | Feld_1_13_1Dto
    | Feld_1_13_2Dto,
  auftrag110: BefehlAuftrag_1_10Dto
) {
  if (!feld?.kennung) return false

  const kennung = feld.kennung

  // Check km fields (1.11.1, 1.12.1, 1.13.1)
  if (kennung === '1.11.1' || kennung === '1.12.1' || kennung === '1.13.1') {
    if (!hasFieldContent(auftrag110, kennung, 'km')) {
      return true
    }
  }

  // Check zeile fields (1.11.2, 1.12.2, 1.13.2)
  if (kennung === '1.11.2' || kennung === '1.12.2' || kennung === '1.13.2') {
    // Signal+Zugmeldestelle fields need both signal AND zugmeldestelle.name
    const hasSignal = hasFieldContent(auftrag110, kennung, 'signal')
    const hasZugmeldestelle = hasFieldContent(
      auftrag110,
      kennung,
      'zugmeldestelle.name'
    )

    // Both must have content
    if (!(hasSignal && hasZugmeldestelle)) {
      return true
    }
  }
  return false
}
